<template>
  <div
    v-if="isReporting"
    class="SupplierMaintenanceReport"
  >
    <div class="header">
      <img
        src="@/assets/img/login/logo.png"
        alt="智生活 Logo"
      >
    </div>
    <div class="body">
      <div class="asset-name-position">
        <div class="asset-name">
          項目：{{ data.Name }}
        </div>
        <div class="asset-position">
          位置：{{ data.Location }}
        </div>
      </div>
      <div class="report">
        <div class="title">
          維養回報
        </div>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
        >
          <el-form-item
            label="確認維養完成"
            prop="isDone"
          >
            <el-radio-group v-model="form.isDone">
              <el-radio label="完成" />
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="下次維養日期"
            required
          >
            <el-form-item prop="nextDate">
              <el-date-picker
                v-model="form.nextDate"
                type="date"
                placeholder="選擇日期"
                style="width: 100%;"
                :picker-options="pickerOptions"
              />
            </el-form-item>
          </el-form-item>
        </el-form>
        <div class="button-container">
          <el-button @click="clickCancel">
            取消
          </el-button>
          <el-button
            type="primary"
            @click="clickSubmit"
          >
            回報
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiAsset } from '../../api/smartBuildingSystemAPI'
export default {
  props: {
    data: {
      type: Object
    },
    category: {
      type: String
    }
  },
  data () {
    const emptyForm = {
      isDone: null,
      nextDate: ''
    }
    const form = {
      ...emptyForm
    }
    const rules = {
      isDone: [
        { required: true, message: '必填欄位不可為空', trigger: 'change' }
      ],
      nextDate: [
        { required: true, message: '必填欄位不可為空', trigger: 'change' }
      ]
    }
    const isReporting = false
    return {
      emptyForm,
      form,
      rules,
      isReporting
    }
  },
  computed: {
    pickerOptions () {
      // 限制可選擇日期
      return {
        disabledDate (time) {
          return time.getTime() < (new Date()).getTime()
        }
      }
    }
  },
  methods: {
    clickCancel (e) {
      e.stopPropagation()
      this.form = {
        ...this.emptyForm
      }
      this.isReporting = false
    },
    clickSubmit (e) {
      e.stopPropagation()
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            const TermId = this.data.TermId
            const jwt = this.$route.query.jwt
            const nextTime = new Date(this.form.nextDate).toISOString()
            const req = {
              TermId,
              EquipmentCategory: this.category,
              EquipmentLocation: this.data.Location,
              EquipmentName: this.data.Name,
              NextTime: nextTime,
              State: 'done'
            }
            await apiAsset.maintenance.postSupplierMaintenanceReport(req, jwt)
            this.$message.success('回報成功')
            this.$emit('reported', nextTime)
            this.isReporting = false
          } catch (error) {
            this.$message.error('發生未知錯誤，請稍後再試')
            console.log(error)
          }
        } else {
          this.$message.error('必填欄位不可為空')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.SupplierMaintenanceReport {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: -webkit-fill-available;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}
.header {
  height: 64px;
  background-color: $mainColor;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    height: 39px;
  }
}
.body {
  flex-grow: 1;
  padding: 36px 16px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  overflow-y: scroll;
  .title {
    font-size: 17px;
    text-align: start;
    font-weight: bold;
    margin-bottom: 22px;
  }
  .asset-name-position {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .button-container {
    width: 100%;
    display: flex;
    justify-content: center;
  }
}
::v-deep .el-form-item {
  display: flex;
  flex-direction: column;
  .el-form-item__label {
    text-align: start;
  }
}
</style>
